module.exports = __webpack_public_path__ + "static/media/comparison_icon_grey.167655ba.svg";